import React from 'react';
export const useCheckMidClick = () => {
    const isMidClick = React.useRef(false);
    const onMouseDown = () => {
        isMidClick.current = true;
    };
    const onMouseUp = () => {
        isMidClick.current = false;
    };
    return React.useMemo(() => ({
        elementProps: {
            onMouseDown,
            onMouseUp,
        },
        isMidClick,
    }), []);
};
